// extracted by mini-css-extract-plugin
export var active = "_j9-e";
export var blink = "_j9-f";
export var dropDownSelector = "_j9-5";
export var dropDownWrapper = "_j9-4";
export var fakeCursor = "_j9-d";
export var fontSizeButton = "_j9-7";
export var formQuillEditor = "_j9-0";
export var pressed = "_j9-g";
export var qlBlank = "_j9-1";
export var textFormattingToolbar = "_j9-2";
export var textFormattingToolbarClosed = "_j9-3";
export var textFormattingToolbarInline = "_j9-6";
export var textToolbarOption = "_j9-8";
export var toolbarCell = "_j9-a";
export var toolbarCellCollapsed = "_j9-b";
export var toolbarOptionHitArea = "_j9-c";
export var toolbarOverflow = "_j9-9";